import { createStore } from "vuex";

export default createStore({
  state: {
    packSelected: []
  },
  getters: {},
  mutations: {
    SAVE_PACK(state, payload){
      state.packSelected = payload
    }
  },
  actions: {},
  modules: {},
});
